module.exports = "/_next/static/images/RealTimeAudience@2x-081c1bbddbd3da68e12f85da6d165823.webp";